'use client';
import React from 'react';
import { Bell, Search } from 'lucide-react';

export default function AdminTopbar() {
  return (
    <header className="h-16 bg-white border-b border-border flex items-center justify-between px-6 lg:px-8 shrink-0">
      <div className="relative max-w-xs w-full">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
        <input
          type="text"
          placeholder="Search bookings, guests..."
          className="w-full pl-9 pr-4 py-2 bg-muted rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-ring"
        />
      </div>
      <div className="flex items-center gap-3">
        <button className="relative p-2 rounded-xl hover:bg-muted transition-colors" aria-label="Notifications">
          <Bell size={18} className="text-muted-foreground" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-primary rounded-full" />
        </button>
        <div className="flex items-center gap-2 pl-3 border-l border-border">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white text-sm font-700">
            M
          </div>
          <div className="hidden sm:block">
            <p className="text-sm font-600 text-foreground leading-none">Maria Santos</p>
            <p className="text-xs text-muted-foreground">Property Owner</p>
          </div>
        </div>
      </div>
    </header>
  );
}